//TODO: to be reviewed by sshrivastava
import { PermissionEnums } from '@yodlee/common-components/dist/types/enumerations';
import { NotificationUtils } from '@yodlee/common-components/dist/utilities';
import { Col, Icon, Row, Spin } from 'antd';
import { cloneDeep, findIndex } from "lodash";
import React, { useEffect, useRef, useState } from 'react';
import { AmplitudeEventsUtils, DataUtils, RoleGroupUtils } from '../../utilities';
import Groups from "./groups";
import GroupUsers from "./groups-users";
var ManageGroups = function (_a) {
    var authentication = _a.authentication, onCloseClick = _a.onCloseClick;
    var _b = useState(), onload = _b[0], setOnload = _b[1];
    var _c = useState(), localGroupsData = _c[0], updateLocalGroupsData = _c[1];
    var _d = useState(), selectedGroupData = _d[0], updateSelectedGroupData = _d[1];
    var _e = useState(0), activeGroupIndex = _e[0], updateActiveGroupIndex = _e[1];
    var _f = useState(false), isLoading = _f[0], toggleLoading = _f[1];
    var _g = useState(), permissions = _g[0], updatePermissions = _g[1];
    useEffect(function () {
        toggleLoading(true);
        DataUtils.onload(authentication).get(undefined, false).then(function (onload) {
            setOnload(onload);
            DataUtils.permission(authentication).get(onload.user.id).then(function (permissions) { return updatePermissions(permissions); });
        }).finally(function () {
            fetchGroupsData(-1);
        });
    }, [authentication.selectedBrand]);
    var fetchGroupsData = function (groupId) {
        toggleLoading(true);
        DataUtils.group(authentication).getAll().then(function (groups) {
            updateLocalGroupsData(groups);
            var activeIndex = activeGroupIndex;
            if (groupId > -1) {
                activeIndex = findIndex(groups, function (obj) { return obj.id === groupId; });
                RoleGroupUtils.scrollToRole("grp-" + groupId, "grp-cntnr-list");
            }
            if (activeIndex < 0 || activeIndex >= groups.length) {
                activeIndex = groups.length - 1;
            }
            updateActiveGroupIndex(activeIndex);
            updateSelectedGroupData(groups[activeIndex]);
        }).finally(function () {
            toggleLoading(false);
        });
    };
    var fetchSelectedGroupData = function (groupId) {
        toggleLoading(true);
        DataUtils.group(authentication).get(groupId)
            .then(function (group) {
            updateSelectedGroupData(group);
            updateGroupsData(groupId, group);
        }).finally(function () {
            toggleLoading(false);
        });
    };
    var updateGroupsData = function (groupId, groupData) {
        if (!groupId)
            return;
        var currentGroupsData = localGroupsData;
        if (currentGroupsData && Array.isArray(currentGroupsData)) {
            for (var _i = 0, currentGroupsData_1 = currentGroupsData; _i < currentGroupsData_1.length; _i++) {
                var grp = currentGroupsData_1[_i];
                if (grp.id === groupId) {
                    grp.users = groupData.users;
                    break;
                }
            }
            updateLocalGroupsData(cloneDeep(currentGroupsData));
        }
    };
    var addgroup = function (groupName) {
        var newGroupName = groupName || "New group";
        var groupNames = RoleGroupUtils.getAllNames(localGroupsData);
        newGroupName = RoleGroupUtils.getNewName(groupNames, newGroupName);
        if (!newGroupName)
            return;
        toggleLoading(true);
        DataUtils.group(authentication).create({ id: 0, name: newGroupName, users: [] }).then(function (group) {
            fetchGroupsData(group.id);
        }).catch(function (err) {
            var _a, _b;
            toggleLoading(false);
            // message.warning(err?.response?.data?.message);
            NotificationUtils.warning("Request failed.", (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
        }).finally(function () {
            AmplitudeEventsUtils.manageGroupAddGroup(newGroupName);
        });
    };
    var deleteGroup = function (groupId) {
        if (!groupId)
            return;
        toggleLoading(true);
        DataUtils.group(authentication).delete(groupId).then(function (group) {
            fetchGroupsData(-1);
        }).catch(function (err) {
            var _a, _b;
            toggleLoading(false);
            // message.warning(err?.response?.data?.message);
            NotificationUtils.warning("Request failed.", (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
        });
    };
    var renameGroup = function (groupId, groupName) {
        toggleLoading(true);
        DataUtils.group(authentication).update(groupId, { id: groupId, name: groupName, users: selectedGroupData === null || selectedGroupData === void 0 ? void 0 : selectedGroupData.users }).then((function (group) {
            fetchGroupsData(groupId);
        })).catch(function (err) {
            var _a, _b;
            toggleLoading(false);
            // message.warning(err?.response?.data?.message);
            NotificationUtils.warning("Request failed.", (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
        }).finally(function () {
            AmplitudeEventsUtils.manageGroupRenameGroup(groupName);
        });
    };
    var makeChangesToGroup = function (groupId, groupName, userList) {
        toggleLoading(true);
        DataUtils.group(authentication).update(groupId, { id: groupId, name: groupName, users: userList }).then((function (groupData) {
            // updateSelectedGroupData(groupData);
            // updateGroupsData(groupId, groupData);
            fetchSelectedGroupData(groupId);
        })).catch(function (err) {
            var _a, _b;
            toggleLoading(false);
            // message.warning(err?.response?.data?.message);
            NotificationUtils.warning("Request failed.", (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
        });
    };
    var groupUsersRef = useRef();
    var onGroupIndexUpdate = function (index) {
        if (activeGroupIndex !== index) {
            updateActiveGroupIndex(index);
            updateSelectedGroupData(localGroupsData[index]);
            if (!groupUsersRef.current)
                return;
            groupUsersRef.current.resetStates();
        }
    };
    var isViewOnly = true;
    for (var _i = 0, _h = (permissions || []); _i < _h.length; _i++) {
        var perm = _h[_i];
        if (perm.id === PermissionEnums.SERVICE_REQUESTS.SUPPORT_GROUPS && perm.type === 2) {
            isViewOnly = false;
            break;
        }
    }
    return (React.createElement(Spin, { spinning: isLoading, delay: 300, size: "large", indicator: React.createElement(Icon, { type: "loading", spin: true }) },
        React.createElement(Row, { style: { height: "100%", width: "100%" }, className: "mng-roles-container" },
            React.createElement(Col, { span: 8, className: "mng-roles-col brdr-rgt" },
                React.createElement(Groups, { groupsData: localGroupsData, onGroupIndexUpdate: onGroupIndexUpdate, handleGroupAddition: addgroup, handleGroupDeletion: deleteGroup, activeGroupIndex: activeGroupIndex, handleGroupRename: renameGroup, isViewOnly: isViewOnly })),
            React.createElement(Col, { span: 16, className: "mng-roles-col brdr-rgt" },
                React.createElement(GroupUsers, { ref: groupUsersRef, authentication: authentication, selectedGroupData: selectedGroupData, updateGroupDetails: makeChangesToGroup, onload: onload, isViewOnly: isViewOnly })))));
};
export default ManageGroups;
//# sourceMappingURL=index.js.map